<template>
  <div>
    <div class="r-text-headline-paragraph">איך קוראים לך?</div>
    <div class="r-form">
      <div class="r-form-row">
        <default-text-input
          :value="firstName"
          label="שם פרטי"
          autofocus
          validations="required|nameCharacters"
          @observe="observe"
          @input="setFirstName" />
      </div>

      <div class="r-form-row">
        <default-text-input
          :value="lastName"
          label="שם משפחה"
          validations="required|nameCharacters"
          @observe="observe"
          @input="setLastName"/>
      </div>
    </div>
    <default-button label="הבא >" @click="nextPage"/>
    <go-to-login/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import TrackedPage from '@/mixins/TrackedPage';
import ValidationObserver from '@/mixins/ValidationObserver';
import DefaultButton from '@/components/styled/DefaultButton';
import DefaultTextInput from '@/components/styled/DefaultTextInput';
import ScrollToTop from '@/mixins/ScrollToTop';
import GoToLogin from '@/components/GoToLogin';

export default {
  name: 'SignupName',
  mixins: [TrackedPage, ValidationObserver, ScrollToTop],
  components: { DefaultTextInput, DefaultButton, GoToLogin },
  computed: {
    ...mapState('signup', ['firstName', 'lastName']),
  },
  methods: {
    ...mapMutations('signup', ['setFirstName', 'setLastName']),
    async nextPage() {
      const { valid } = await this.validate();
      if (valid) {
        await this.$router.push('contact');
      }
    },
  },
};
</script>
